/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_In_Reason_From_Customer_ReturnInputs */

const vi_pll_in_reason_from_customer_return = /** @type {(inputs: Pll_In_Reason_From_Customer_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách hàng trả về`)
};

/**

* @param {Pll_In_Reason_From_Customer_ReturnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_in_reason_from_customer_return = /** @type {((inputs?: Pll_In_Reason_From_Customer_ReturnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_In_Reason_From_Customer_ReturnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_in_reason_from_customer_return(inputs)
});